import { useCallback } from "react";
import { Popconfirm, Button, message } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import { announcement as announcementService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function AnnouncementRecallButton({ messageId, callback }) {
  const auth = useAuthContext();
  const confirmHandler = useCallback(() => {
    announcementService.recallAnnouncement(messageId, auth.token).then(() => {
      message.success("操作成功");
      callback(Date.now());
    });
  }, [messageId, auth, callback]);
  return (
    <Popconfirm
      title="请确认?"
      onConfirm={confirmHandler}
      okText="是"
      cancelText="否"
    >
      <Button size="small" icon={<RollbackOutlined />} />
    </Popconfirm>
  );
}

export default AnnouncementRecallButton;
